<template>
  <v-dialog transition="dialog-bottom-transition" v-model="$store.state.dialog.visible" persistent max-width="500">
    <v-card>
      <v-card-title
        v-if="$store.state.dialog.title"
        style="background: var(--back-header); padding: 0px; overflow: hidden; display: flex; justify-content: center">
        {{ $store.state.dialog.title }}
      </v-card-title>
      <v-card-text style="background: var(--back-content); padding: 20px; width: 100%; text-align: center">
        {{ $store.state.dialog.text }}
        <v-text-field ref="promptField" v-model="inputText" dark v-if="$store.state.dialog.prompt" @keydown.enter="confirm()"></v-text-field>
      </v-card-text>
      <v-card-actions style="background: var(--back-content); padding: 0px; overflow: hidden; display: flex">
        <v-spacer v-if="$store.state.dialog.buttonConfirmText"></v-spacer>
        <v-btn
          v-if="$store.state.dialog.buttonConfirmText"
          x-small
          style="width: 120px"
          @click="confirm()">
          {{ $store.state.dialog.buttonConfirmText }}
        </v-btn>
        <v-spacer></v-spacer>
        <v-btn
          v-if="$store.state.dialog.buttonCancelText"
          x-small
          style="width: 120px"
          @click="
            $store.state.dialog.cancelCallback();
            $store.state.dialog.visible = false;
          ">
          {{ $store.state.dialog.buttonCancelText }}
        </v-btn>

        <v-spacer v-if="$store.state.dialog.buttonCancelText"></v-spacer>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  props: {},
  data: () => {
    return {
      inputText: "",
    };
  },
  watch: {
    // A reused prompt starts from its default again, selected so typing replaces it.
    "$store.state.dialog.visible"(open) {
      if (!open) return;
      this.inputText = this.$store.state.dialog.prompt;
      setTimeout(() => {
        const input = this.$refs.promptField && this.$refs.promptField.$el.querySelector("input");
        if (input) input.select();
      }, 0);
    },
  },
  methods: {
    confirm() {
      this.$store.state.dialog.confirmCallback(this.inputText);
      this.$store.state.dialog.visible = false;
    },
  },
};
</script>
